import React from "react";
import SegmentToggle from "./SegmentToggle";

const SALE_OPTIONS = [
  {
    value: "SALE",
    label: "Sale",
    activeClass: "bg-main text-white shadow-sm ring-1 ring-main/20",
  },
  {
    value: "RETURN",
    label: "Return",
    activeClass: "bg-danger text-white shadow-soft ring-1 ring-danger/30",
  },
];

const SaleType = ({ saleType, setSaleType }) => (
  <SegmentToggle
    label="Transaction type"
    options={SALE_OPTIONS}
    value={saleType}
    onChange={setSaleType}
  />
);

export default SaleType;
